'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

(function (EmailStatusType) {
    EmailStatusType["bounce"] = "bounce";
    EmailStatusType["canceled"] = "canceled";
    EmailStatusType["click"] = "click";
    EmailStatusType["delay"] = "delay";
    EmailStatusType["delivery"] = "delivery";
    EmailStatusType["failed"] = "failed";
    EmailStatusType["generation_failure"] = "generation_failure";
    EmailStatusType["generation_rejection"] = "generation_rejection";
    EmailStatusType["invalid"] = "invalid";
    EmailStatusType["list_unsubscribe"] = "list_unsubscribe";
    EmailStatusType["open"] = "open";
    EmailStatusType["pending"] = "pending";
    EmailStatusType["policy_rejection"] = "policy_rejection";
    EmailStatusType["sent"] = "sent";
    EmailStatusType["spam_complaint"] = "spam_complaint";
})(exports.EmailStatusType || (exports.EmailStatusType = {}));
